"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const flora_default_1 = __importDefault(require("./flora-default"));
exports.default = Object.assign(Object.assign({}, flora_default_1.default), { name: 'Contraste', colors: Object.assign(Object.assign({}, flora_default_1.default.colors), { build: {
            brand: {
                primary: '#000000',
                secondary: '#000000',
                tertiary: '#000000',
            },
            dark: {
                default: '#000000',
                light: '#000000',
            },
            light: {
                default: '#FFFFFF',
                dark: {
                    primary: '#F5F5F5',
                    secondary: '#FFFFFF',
                },
            },
            medium: {
                default: '#878787',
                light: {
                    primary: '#515151',
                    secondary: '#CCCCCC',
                },
            },
            gradient: {
                primary: {
                    first: '#000000',
                    end: '#000000',
                },
                secondary: {
                    first: '#000000',
                    end: '#000000',
                },
            },
        }, action: {
            conversion: {
                static: '#000000',
                highlight: '#304873',
                disabled: 'rgba(0, 0, 0, 0.16)',
            },
            navigation: {
                standard: {
                    static: '#000000',
                    highlight: '#37736C',
                    disabled: 'rgba(0, 0, 0, 0.16)',
                },
                alt: {
                    static: '#FFFFFF',
                    highlight: '#000000',
                    disabled: 'rgba(255, 255, 255, 0.24)',
                },
            },
            gradient: {
                conversion: {
                    first: '#000000',
                    end: '#000000',
                },
                navigation: {
                    first: '#000000',
                    end: '#000000',
                },
            },
        } }) });
